// custom-global.jsでindexのFVは変数作成済み
// const indexFv = document.querySelector(".index-fv");
const aboutFv = document.querySelector(".about-fv");
const productFv = document.querySelector(".product-fushimino-fv");

// customCta
const customCta = document.querySelector(".custom-cta");
const customCtaHiddenClass = "is-hidden";

const showCustomCta = function () {
  customCta?.classList.remove(customCtaHiddenClass);
};

const hideCustomCta = function () {
  customCta?.classList.add(customCtaHiddenClass);
};

const CtaOptions = {
  root: null,
  rootMargin: "0px",
  threshold: 0.8,
};

//footerが見えている時のCTAだしわけ
const customFooter = document.querySelector("#shopify-section-footer");
let customFooterObserver = new IntersectionObserver(customFooterCallback);
if (customFooter) {
  customFooterObserver.observe(customFooter);
}
function customFooterCallback(entries) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      hideCustomCta();
    } else {
      showCustomCta();
    }
  });
}

//About FVが見えている際のだしわけ
let aboutFvObserver = new IntersectionObserver(aboutFvCallback, CtaOptions);

if (aboutFv) {
  aboutFvObserver.observe(aboutFv);
}
function aboutFvCallback(entries) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      hideCustomCta();
    } else {
      showCustomCta();
    }
  });
}

let productFvObserver = new IntersectionObserver(productFvCallback, CtaOptions);

if (productFv) {
  productFvObserver.observe(productFv);
}
function productFvCallback(entries) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      hideCustomCta();
    } else {
      showCustomCta();
    }
  });
}

//Index FVが見えている際のだしわけ
let indexFvObserver = new IntersectionObserver(indexFvCallback, CtaOptions);

if (indexFv) {
  indexFvObserver.observe(indexFv);
}
function indexFvCallback(entries) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      hideCustomCta();
    } else {
      showCustomCta();
    }
  });
}
